<template>
  <LayoutController>
    <Icon />
    <AnalyticsIcon />
    <RouterView class="Simple" />
  </LayoutController>
</template>

<script>
import LayoutController from '@/components/parts/LayoutController'
import Icon from '@/components/icons'
import AnalyticsIcon from '@/components/icons/AnalyticsIcon.vue'
export default {
  components: { Icon, AnalyticsIcon, LayoutController },
  metaInfo: {
    bodyAttrs: {
      class: 'print',
    },
  },
  name: 'SimpleLayout',
}
</script>

<style lang="scss">
body.print {
  background-color: #f3f3f7;
}
</style>
